import { FormattedMessage } from 'react-intl'
import InclusionsTable from './InclusionsTable'
import ToggleInclusions from './ToggleInclusions'
import {
  getTitle,
  getGuestName,
  sectionWithoutMandatoryOrIncluded,
} from './ResortGuestInclusions'
import { Fragment } from 'react'

export default function LaGuestInclusions({
  fields,
  guestType,
  totalGuests = 0,
}) {
  if(!fields.length) {
    return null
  }
  return fields.map((name, index) => {
    const currentGuest = fields.value[index]
    const rentalEquipmentCleared = sectionWithoutMandatoryOrIncluded(
      currentGuest.rentalEquipment
    )
    const extras = sectionWithoutMandatoryOrIncluded(currentGuest.extras)
    const hasRentalEquipment =
      rentalEquipmentCleared && !!rentalEquipmentCleared.length
    const hasExtras = extras && !!extras.length
    const hasCourses = currentGuest.courses && !!currentGuest.courses.length
    const noItems = !hasRentalEquipment && !hasExtras && !hasCourses
    return (
      <div key={index}>
        <h4 className='subtitle'>
          {getGuestName(index + totalGuests) || (
            <Fragment>
              {getTitle(guestType)} {index + 1}
            </Fragment>
          )}
        </h4>
        <InclusionsTable>
          {hasRentalEquipment && (
            <ToggleInclusions
              name={`${name}.rentalEquipment`}
              sectionTitle={
                <FormattedMessage
                  id='add_rental_equipment'
                  defaultMessage='Add some rental equipment'
                />
              }
            />
          )}
          {hasExtras && (
            <ToggleInclusions
              name={`${name}.extras`}
              sectionTitle={
                <FormattedMessage
                  id='add_other_options'
                  defaultMessage='Add other dive options'
                />
              }
            />
          )}
          {hasCourses && (
            <ToggleInclusions
              name={`${name}.courses`}
              sectionTitle={
                <FormattedMessage
                  id='add_a_course'
                  defaultMessage='Add a course'
                />
              }
            />
          )}
          {noItems && <ToggleInclusions isStudent />}
        </InclusionsTable>
      </div>
    )
  })
}
